import React from 'react';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import { useTranslation } from 'react-i18next';

import MainComponent from '../../commons/main/mainComponent';

const ResetView = ({
    success,
    message,
    handleInputChange,
    handleReset,
    matchPassword,
}) => {
    const { t } = useTranslation();

    return (
        <MainComponent>
            <h3 className="text-center">{t('reset.title')}</h3>
            {message ? (
                <Alert variant={!success ? 'danger' : 'success'}>
                    {t(message.key, message.params)}
                </Alert>
            ) : null}
            <ValidationForm
                onSubmit={(e) => {
                    e.preventDefault();
                    handleReset(e);
                }}
            >
                <Form.Group>
                    <Form.Label>{t('reset.password')}</Form.Label>
                    <TextInput
                        type="password"
                        onChange={handleInputChange}
                        name="password"
                        required
                        pattern="[^\n]{6,}"
                        errorMessage={{
                            required: t('reset.passwordRequired'),
                            pattern: t('reset.passwordTooShort'),
                        }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>{t('reset.passwordAgain')}</Form.Label>
                    <TextInput
                        type="password"
                        onChange={handleInputChange}
                        name="passwordAgain"
                        required
                        validator={matchPassword}
                        errorMessage={{ validator: t('reset.passwordsMismatch') }}
                    />
                </Form.Group>
                <Button type="submit" variant="success">
                    {t('reset.submit')}
                </Button>
            </ValidationForm>
            <hr />
            <div className="btm-links">
                <p>
                    <Link to="/">{t('common.back')}</Link>
                </p>
            </div>
        </MainComponent>
    );
};

export default ResetView;
